import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';

import {
  InputField,
  SelectField,
  RadioField,
  required,
  number,
  minValue,
  maxValue,
  url,
  isValidSlug
} from '../../form';

class WebsiteFormFields extends Component {
  render() {
    const { formAction, website } = this.props;
    
    return (
      <div>
        <Field
          type='text'
          name='website[name]'
          placeholder='Name of your website'
          label='Name'
          component={InputField}
          validate={[required, isValidSlug]}
        />
        <Field
          type='text'
          name='website[url]'
          placeholder='URL of your website'
          label='URL'
          component={InputField}
          validate={[required, url]}
        />
        <Field
          type='number'
          name='website[cpa]'
          placeholder='Min. cost per applicant'
          label='Cost Per Applicant ($)'
          component={InputField}
          validate={[required, number, minValue(1)]}
        />
        <Field
          type='number'
          name='website[cpc]'
          placeholder='Min. cost per click'
          label='Cost Per Click ($)'
          component={InputField}
          validate={[required, number, minValue(0.10)]}
        />

        <Field
          type='text'
          name='website[default_slots]'
          placeholder='Number of slots'
          label='Slots'
          component={SelectField}
          options={[
            { label: '1', value: 1 },
            { label: '2', value: 2 },
            { label: '3', value: 3 },
            { label: '4', value: 4 },
            { label: '5', value: 5 }
          ]}
          normalize={(e) => e.value}
          validate={[required, number, minValue(1), maxValue(5)]}
        />

        {formAction === 'Update' && <Field
          name='website[sandbox]'
          label='Website Mode'
          options={[['sandbox', 'Sandbox'], ['live', 'Live']]}
          defaultValue={'sandbox'}
          component={RadioField}
          disabled={(website || {}).status === 'pending'}
        /> }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { loader } = state;
  const { website, formAction } = ownProps;
  const isLoading = loader.includes('WebsiteForm');

  return { isLoading, website, formAction };
};

export default connect(mapStateToProps)(WebsiteFormFields);
